<template>
  <div class="main" v-if="bkmenu">
    <!-- {{ bkmenu}} -->
    <van-row>
      <van-col span="12" align="left" class="label">群組</van-col>
      <van-col span="12" align="right">
        <el-button type="primary" @click="cmdCreate()">新增</el-button>
      </van-col>
    </van-row>
    <van-divider />

    <el-table :data="bkmenu.extgroup" stripe style="width: 100%">
      <el-table-column label="名稱" width="200">
        <template slot-scope="scope">
          <el-button type="text" @click="cmdEdit(scope.$index, scope.row)">{{
            scope.row.id
          }}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="內容物類型" width="140">
        <template slot-scope="scope">
          {{ columns[scope.row.type] }}
        </template>
      </el-table-column>
      <el-table-column label="群組使用了">
        <!-- <template slot-scope="scope">
          <span v-for="(o, index) in scope.row.options" :key="o.ItemName">
            <span v-if="findItem(o)">{{ o.ItemName }}</span>
            <span v-else>
              <el-button type="text" class="danger" @click="cmdNotFind(o)">{{
                o.ItemName
              }}</el-button>
            </span>
            <span v-if="index != scope.row.options.length - 1">、</span>
          </span>
        </template> -->
        <template slot-scope="scope">
          <span v-for="(o, index) in scope.row.options" :key="o.ItemName">
            <span v-if="findItem(o)">
              <!-- {{ o.ItemName }} -->

              <el-button type="text" @click="cmdEditItem(scope.$index, o)">
                {{ o.ItemName }}
              </el-button>
            </span>
            <span v-else>
              <el-button type="text" class="danger" @click="cmdNotFind(o)">{{
                o.ItemName
              }}</el-button>
            </span>
            <span v-if="index != scope.row.options.length - 1">、</span>
          </span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="key" label="key"> </el-table-column> -->
      <!-- <el-table-column label="操作" align="right">
        <template slot-scope="scope">
          <el-button size="mini" type="danger" @click="cmdEdit(scope.$index, scope.row)"
            >編輯</el-button
          >
        </template>
      </el-table-column> -->
    </el-table>

    <FrmEditGroup ref="rEditGroup" @ok="refresh" />
    <FrmEditItem ref="rEditItem" @ok="refresh" />
  </div>
</template>

<style scoped>
.danger {
  color: red;
}
.label {
  font-size: 2rem;
  font-weight: bold;
}
.main {
  padding: 1rem;
  text-align: left;
}
</style>

<script>
export default {
  async mounted() {
    await this.refresh();
  },
  data() {
    return {
      bkmenu: null,
      columns: {
        S2: "附餐",
        AN: "口味",
        S1: "主餐",
        A1: "口味項目",
        NEXT: "下一步",
      },
    };
  },
  methods: {
    cmdNotFind(obj) {
      this.gMsgbox(
        "POS菜單中找不到對應的品項<br>類別編號:" + obj.TypeNo + "," + obj.ItemName
      );
    },
    async refresh() {
      this.gLoading();
      var res = await this.apiGetBKMenu();
      this.bkmenu = res.data;
      this.gClearLoading();
    },
    cmdCreate() {
      this.$refs.rEditGroup.showCreate();
    },
    cmdEdit(rowIndex, obj) {
      this.$refs.rEditGroup.showEdit(rowIndex, obj);
    },
    cmdEditItem(rowIndex, obj) {
      this.$refs.rEditItem.showEdit(rowIndex, obj);
    },
    async init() {
      try {
        var res = await this.apiGetBKMenu();
        this.bkmenu = res.data;
      } catch (error) {
        console.log(error);
      }
    },
    printOptions(options) {
      var output = [];
      options.forEach((r) => {
        output.push(r.ItemName);
      });
      return output.join("、");
      // return options;
    },
    add() {
      this.$router.push("edit-group");
    },

    handleEdit(index, row) {
      console.log(index, row);
      // this.bkgroup.options.splice(index, 1);
      this.$router.push({ path: "edit-group", query: { key: row.key } });
    },
    async handleDelete(index, row) {
      var body = { key: row.key };
      var res = await this.apiDeleteExtgroup(body);
      console.log(index, res);
    },
    findItem(obj) {
      var find = this.bkmenu.menuitem.find(
        (r) => r.ItemName == obj.ItemName && r.TypeNo == obj.TypeNo
      );
      if (find) {
        return true;
      }
      return false;
    },
  },
};
</script>
